var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import contService from "@/core/services/contService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { ContasActions } from "@/store/enums/ContEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let ContasModule = class ContasModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = ContasActions.POST_CONTAS](data) {
        return new Promise(resolve => {
            contService.post("Contas/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = ContasActions.PUT_CONTAS](data) {
        return new Promise(resolve => {
            contService.put("Contas/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = ContasActions.DELETE_CONTAS](data) {
        return new Promise(resolve => {
            contService.delete("Contas/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = ContasActions.DELETE_RANGE_CONTAS](data) {
        return new Promise(resolve => {
            contService.delete("Contas/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = ContasActions.FILTER_CONTAS](data) {
        return new Promise(resolve => {
            contService.post("Contas/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = ContasActions.GET_CONTAS]() {
        return new Promise(resolve => {
            contService.get("Contas/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = ContasActions.GETWITHDISABLED_CONTAS]() {
        return new Promise(resolve => {
            contService.get("Contas/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = ContasActions.GET_BY_ID_CONTAS](data) {
        return new Promise(resolve => {
            contService.get("Contas/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ContasModule.prototype, _h, null);
ContasModule = __decorate([
    Module
], ContasModule);
export default ContasModule;
//********** COMENTÁRIO GERADO EM: 30/09/2022 10:16:53 **********
//
//import contService from "@/core/services/contService";
//import JwtService from "@/core/services/JwtService";
//import { Mutations } from "@/store/enums/StoreEnums";
//import { ContasActions } from "@/store/enums/ContEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class ContasModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//
//    @Action
//    [ContasActions.POST_CONTAS] (data) {
//        return new Promise(resolve => {
//			contService.post("Contas/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//    
//    @Action
//    [ContasActions.POSTBACK_CONTAS] (data) {
//        return new Promise(resolve => {
//			contService.post("Contas/PostBack", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[ContasActions.PUT_CONTAS] (data) {
//        return new Promise(resolve => {
//            contService.put("Contas/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[ContasActions.DELETE_CONTAS](data) {
//        return new Promise(resolve => {
//            contService.delete("Contas/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[ContasActions.DELETE_RANGE_CONTAS](data) {
//        return new Promise(resolve => {
//            contService.delete("Contas/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[ContasActions.FILTER_CONTAS](data) {
//        return new Promise(resolve => {
//            contService.post("Contas/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[ContasActions.GET_CONTAS]() {
//        return new Promise(resolve => {
//            contService.get("Contas/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [ContasActions.GETWITHDISABLED_CONTAS]() {
//        return new Promise(resolve => {
//            contService.get("Contas/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[ContasActions.GET_BY_ID_CONTAS](data) {
//        return new Promise(resolve => {
//            contService.get("Contas/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=ContasModule.js.map